var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcFirstbgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 53,
    viewBox: "0 0 211 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 769",
    opacity: 0.72,
    d: "M12 27.1092C20.4086 16.6269 43.6968 1.95162 69.5806 27.1092C95.4645 52.2668 123.505 37.5915 134.29 27.1092C144.527 15.7074 171.8 -0.255019 199 27.1092",
    stroke: "url(#paint0_linear_4491_1702)",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4491_1702",
    x1: 105.5,
    y1: 12,
    x2: 104.525,
    y2: 39.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#FFE975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB1F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcFirstbgGreen);
export default __webpack_public_path__ + "static/media/stick-ic-firstbg-green.df01448997d3ec7f486e23a2dd3c57e1.svg";
export { ForwardRef as ReactComponent };